import { Injectable } from '@angular/core';
import { FrappeApp, FrappeCall, FrappeDB } from 'frappe-js-sdk';
import { AppConstant } from '../app.constant';

@Injectable({
    providedIn: 'root'
})
export class ShipmentASN {
    private frappe: FrappeApp;
    private frappeCall: FrappeCall;
    private db:FrappeDB;
    constructor() {
        this.frappe = new FrappeApp(AppConstant.frappeUrl);
        this.frappeCall = this.frappe.call()
        this.db=this.frappe.db()
    }

    public createShipmentASN(shipmentASN: any): Promise<any> {
        return this.frappeCall.post('vendor_portal.api.shipment_asn.create_shipment_asn', { data: JSON.stringify(shipmentASN) })
    }

    public upload_documents_to_shipment_asn(upluadDocumentsASN: any): Promise<any> {
        return this.frappeCall.post('vendor_portal.api.shipment_asn.upload_documents_to_shipment_asn', { data: JSON.stringify(upluadDocumentsASN) })
    }

    public getLoadingPointList(): Promise<any> {
        return this.frappe.call().get('vendor_portal.api.shipment_asn.get_Loading_Point');
    }

    public getUnloadingPointList(): Promise<any> {
        return this.frappe.call().get('vendor_portal.api.shipment_asn.get_Unloading_Point');
    }

    public getDriverList():Promise<any>{
        return this.db.getDocList("Driver",{"fields":['*']})
    }

    public getPackingTypeList(): Promise<any> {
        return this.frappe.call().get('vendor_portal.api.shipment_asn.get_packing_type_list');
    }

    public getVehicleTypeList(): Promise<any> {
        return this.frappe.call().get('vendor_portal.api.shipment_asn.get_vehicle_type_list');
    }

    public getRoute(): Promise<any> {
        return this.frappe.call().get('vendor_portal.api.shipment_asn.get_route');
    }

    public getUserPlantByRole(): Promise<any> {
        return this.frappe.call().get('vendor_portal.rest.get_user_plant_by_role');
    }

    public getLoadingAndUnloadingPoint(): Promise<any> {
        return this.db.getDocList("Loading And Unloading", { "fields": ['*'] })
    }

    public getPlantList(): Promise<any> {
        return this.db.getDocList("Plant", { "fields": ['*'] })
    }

    public getGateList(): Promise<any> {
        return this.db.getDocList("Gate", { "fields": ['*'] })
    }

    public getGateFromPlant(plant:string):Promise<any> {
        return this.frappe.call().get('vendor_portal.api.token.get_gate_from_plant',{ data: JSON.stringify(plant) });
    }

    public getVendorMasterAddresses(): Promise<any> {
        return this.frappe.call().get('vendor_portal.api.shipment_asn.get_vendor_master_addresses');
    }

    public getDistanceList(): Promise<any> {
        return this.db.getDocList("Distance", { "fields": ['*'] })
    }

    public getASNDetail(selectedAsn: string): Promise<any> {
        return this.frappeCall.get('vendor_portal.api.shipment_asn.get_asn_details', {
            selected_asn: selectedAsn
        });
    }

    public download_shipment_excel(shipmentAsn: any): Promise<any> {
        return this.frappeCall.get('vendor_portal.rest.download_shipment_excel', { data: JSON.stringify(shipmentAsn) });
    }


    public getSFSList(): Promise<any> {
        return this.db.getDocList("Schedule For Shipment", { "fields": ['*'] })
    }

    public update_planned_quantity(filteredRes: any): Promise<any> {
        return this.frappeCall.post('vendor_portal.api.shipment_asn.update_planned_quantity', { data: JSON.stringify(filteredRes) });
    }

    public get_selected_item_detail(filteredRes: any): Promise<any> {
        return this.frappeCall.post('vendor_portal.api.shipment_asn.get_selected_item_detail', { data: JSON.stringify(filteredRes) });
    }

    public getInvoiceList(): Promise<any> {
        return this.frappe.call().get('vendor_portal.get_list.get_invoice_list');
    }

    public getInvoiceDate(challan_no: string): Promise<any> {
        return this.frappeCall.get('vendor_portal.get_list.get_invoice_date', {
            challan_number: challan_no
        });
    }

    public CheckASNGrDelivery(selectedAsn: string): Promise<any> {
      return this.frappeCall.get('vendor_portal.rest.check_ASN_gr_delivery', {
          selected_asn: selectedAsn
      });
  }

}
